import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EventsService} from '../../events/events.service';
import {GlobalService} from '../../../global.service';
import {AuthenticationService} from '../../../authentication.service';
import {teamsService} from '../teams.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';

@Component({
  selector: 'elastic-join-team-modal',
  templateUrl: './join-team-modal.component.html',
  styleUrls: ['./join-team-modal.component.scss']
})
export class JoinTeamModalComponent implements OnInit {

  password = '';
  responseMessage = '';
  success = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventsService: EventsService,
    private globalServie: GlobalService, globalService: GlobalService,
    private auth: AuthenticationService,
    private teamsService: teamsService,
    public dialogRef: MatDialogRef<JoinTeamModalComponent>
  ) { }

  ngOnInit() {
  }

  joinTeam() {
    this.teamsService.joinTeam(this.password, this.data.team.team_id).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.responseMessage = response.body.message;
            this.success = response.body.success;
            this.dialogRef.close(this.success);
            break;
        }
      });
  }

}
